import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Link} from 'react-router-dom'
import {Table, Icon, Spin} from 'antd'
import CheckoutForm from './CheckoutForm'
import UnsubscribeModal from './UnsubscribeModal'
import FrozenModal from './FrozenModal'

import {timeFormat} from 'd3-time-format'

import style from './subscription.sass'

const invoiceColumns = [{
  title: 'Status',
  dataIndex: 'paid',
  render: value => value
    ? <span><Icon type='check' style={{color: '#66bb6a'}}/> Paid</span>
    : <span><Icon type='close' style={{color: '#f00'}}/> Not Paid</span>
}, {
  title: 'Date',
  dataIndex: 'date',
  render: value => timeFormat('%Y-%b-%d')(new Date(value)),
}, {
  title: 'Invoice Number',
  dataIndex: 'number'
}, {
  title: 'Amount',
  dataIndex: 'total',
  render: value => '$'+value
}]

@inject('store') @observer
class Subscription extends Component {
  state = {
    cardModal: false,
    unsubscribeModal: false,
    frozenModal: false
  }
  componentDidMount() {
    const {user, subscription} = this.props.store
    subscription.getCards()
    subscription.getInvoices()
    this.setState({frozenModal: user.data.account.is_frozen})
  }
  resetHandler = () => {
    this.props.store.user.reset()
  }
  submitHandler = (e) => {
    e.preventDefault()
    this.props.store.user.changeData()
  }
  changeHandler = (e) => {
    this.props.store.user.changeField(e.target.name, e.target.value)
  }
  toggleProfessional = (checked) => {
    this.props.store.user.changeField('is_professional_trader', checked)
  }
  handleMultiselect = (value) => {
    this.props.store.user.changeField('instruments2', value)
  }
  changePage = (page) => {
    this.props.store.subscription.getInvoices(page)
  }
  openCardModal = () => {
    this.setState({cardModal: true})
  }
  closeCardModal = () => {
    this.setState({cardModal: false})
  }
  addCard = async (token) => {
    await this.props.store.subscription.addCard(token)
    this.closeCardModal()
  }
  openUnsubscribeModal = () => {
    this.setState({unsubscribeModal: true})
  }
  closeUnsubscribeModal = () => {
    this.setState({unsubscribeModal: false})
    this.props.store.user.getUserData()
  }
  frozenModalUpdatePayment = () => {
    this.setState({frozenModal: false})
    this.openCardModal()
  }
  closeFrozenModal = () => {
    this.setState({frozenModal: false})
  }

  render() {
    // const {user, permissions, subscription: {cards, invoices}} = this.props.store
    const {user, subscription: {cards, invoices}} = this.props.store
    const {name: planName, id: planID, is_free_plan: isFreePlan} = user.planSettings[0]
    const {cancelation_date: cancelation_date, is_frozen: isFrozen,
      frozen_date: frozenDate, frozen_due: frozenDue} = user.data.account
    const card = cards.data.length ? cards.data[0] : null
    const account = user.data.account || {}
    const {price, next_payment_at} = account
    const nextPaymentAmount = price ? price.match(/[+-]?\d+(\.\d+)?/g) : null
    const nextPaymentDate = timeFormat('%Y-%b-%d')(new Date(next_payment_at))
    const cancelationDate = cancelation_date ?
      timeFormat('%b %d %Y')(new Date(cancelation_date)) : null
    return(
      <form onReset={this.resetHandler} onSubmit={this.submitHandler} styleName='wrapper'>
        <UnsubscribeModal
          visible={this.state.unsubscribeModal}
          handleCancel={this.closeUnsubscribeModal}
        />
        <FrozenModal
          visible={this.state.frozenModal}
          handleCancel={this.closeFrozenModal}
          handleOk={this.frozenModalUpdatePayment}
        />
        <div styleName='panel'>
          <div styleName='title'>
            <h3>Account Information</h3>
            {planID !== 3 &&
              <Link to='/upgrade'><button type='button' styleName='upgrade-button'>Upgrade</button></Link>
            }
          </div>
          <div styleName='plan'>
            <span styleName='label'>Plan</span>
            <span styleName='value'>{planName}
              {isFrozen ? ' (frozen)': ''}
              {cancelationDate &&
                <span> (untill {cancelationDate})</span>
              }
            </span>
          </div>
          {/*<div>*/}
          {/*  <span styleName='label'>Live Trading</span>*/}
          {/*  <span styleName='value'>*/}
          {/*    {!permissions.checkUpgrade('account.live_trading.enable') ? 'Supported' : 'Requires upgrade to Premium'}*/}
          {/*  </span>*/}
          {/*</div>*/}
          {!isFreePlan && !cancelationDate &&
            <a styleName='unsubscribe-link' onClick={this.openUnsubscribeModal}>Cancel Subscription</a>
          }
        </div>
        <div styleName='panel'>
          <div styleName='title'>
            <h3>Payment Method Information</h3>
            {card
              ? <a onClick={this.openCardModal}><Icon type='edit'/> Edit</a>
              : <a onClick={this.openCardModal}><Icon type='plus'/> Add</a>
            }
            <CheckoutForm
              title='Card data'
              visible={this.state.cardModal}
              onOk={this.addCard}
              onCancel={this.closeCardModal}
              confirmLoading={cards.loading}
            />
          </div>
          {card
            ? <div>
              <div>
                <span styleName='label'>Card Type</span>
                <span styleName='value'><img src={`/img/payment/${card.brand.toLowerCase()}.png`} alt={card.brand}/></span>
              </div>
              <div>
                <span styleName='label'>Card Number</span>
                <span styleName='value'>xxxx xxxx xxxx {card.last4}</span>
              </div>
              <div>
                <span styleName='label'>Country</span>
                <span styleName='value'>{card.country}</span>
              </div>
            </div>
            : <Spin spinning={cards.loading} styleName='spin'/>
          }
        </div>
        {((next_payment_at && price) || cancelationDate) &&
          <div styleName='panel'>
            <div styleName='title'>
              <h3>Next Payment</h3>
            </div>
            {!isFrozen && !cancelationDate &&
              <p>Payment of ${nextPaymentAmount} scheduled on {nextPaymentDate}</p>
            }
            {cancelationDate &&
              <p>Your subscription will be canceled on {cancelationDate}.</p>
            }
            {isFrozen &&
            <p>
              Your account is on hold because we were not able to process your payment on {' '}
              <b>{timeFormat('%b %d %Y')(new Date(frozenDate))}</b>. Please update your payment method by {' '}
              <b>{timeFormat('%b %d %Y')(new Date(frozenDue))}</b> to avoid losing your saved Algorithms. If you have any questions, please email support@algoriz.com
            </p>
            }
          </div>
        }
        <div styleName='panel'>
          <div styleName='title'>
            <h3>Payment History</h3>
          </div>
          <Table
            dataSource={invoices.data}
            rowKey='id'
            columns={invoiceColumns}
            size='small'
            pagination={{
              total: invoices.pagination.count,
              pageSize: invoices.pagination.size,
              current: invoices.pagination.page,
              onChange: this.changePage,
              showTotal: total => `Total ${total} items`
            }}
            loading={invoices.loading}
          />
        </div>
      </form>
    )
  }
}

export default Subscription
